import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "af-panel",
  role: "dialog",
  "aria-label": "Ask the Forge"
}
const _hoisted_2 = { class: "af-head" }
const _hoisted_3 = { class: "af-title" }
const _hoisted_4 = { class: "af-head-btns" }
const _hoisted_5 = {
  ref: "body",
  class: "af-body"
}
const _hoisted_6 = {
  key: 0,
  class: "af-empty"
}
const _hoisted_7 = { class: "af-hello" }
const _hoisted_8 = { class: "af-chips" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "af-q"
}
const _hoisted_11 = { class: "af-a-text" }
const _hoisted_12 = ["start"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "af-src"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "af-src af-related"
}
const _hoisted_17 = { class: "af-src-label" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 2,
  class: "af-chips af-follow"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 1,
  class: "af-thinking",
  role: "status"
}
const _hoisted_22 = {
  key: 2,
  class: "af-error",
  role: "alert"
}
const _hoisted_23 = { class: "af-foot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ai_dictation = _resolveComponent("ai-dictation")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["af", { 'af-is-open': _ctx.open }])
  }, [
    (!_ctx.open)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "ai-btn af-launch",
          "aria-label": "Ask the Forge",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPanel()))
        }, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("svg", {
            "aria-hidden": "true",
            xmlns: "http://www.w3.org/2000/svg",
            width: "17",
            height: "17",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            "fill-rule": "evenodd"
          }, [
            _createElementVNode("path", { d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z" })
          ], -1),
          _createElementVNode("span", null, "Ask the Forge", -1)
        ]))]))
      : (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("header", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[10] || (_cache[10] = _createElementVNode("svg", {
                "aria-hidden": "true",
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "currentColor",
                "fill-rule": "evenodd"
              }, [
                _createElementVNode("path", { d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z" })
              ], -1)),
              _createElementVNode("div", null, [
                _cache[9] || (_cache[9] = _createElementVNode("b", null, "Ask the Forge", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.companyName), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.thread.length)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "af-icon-btn",
                    title: "Start a new conversation",
                    "aria-label": "New conversation",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clear()))
                  }, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", { d: "M12 5v14M5 12h14" })
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "af-icon-btn",
                title: "Close",
                "aria-label": "Close",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.open = false))
              }, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" })
                ], -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.thread.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, "Ask anything about how " + _toDisplayString(_ctx.companyName) + " works. The Forge answers from your playbook and shows you where it found it.", 1),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "af-src-label" }, "Try one of these", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.examples, (e) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: e.q,
                        type: "button",
                        class: "af-chip",
                        onClick: ($event: any) => (_ctx.ask(e.q))
                      }, _toDisplayString(e.label), 9, _hoisted_9))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thread, (m, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                (m.role == 'user')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(m.text), 1))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["af-a", { 'af-a-miss': !m.found }])
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blocks(m.text), (b, j) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                            (b.list)
                              ? (_openBlock(), _createElementBlock("ol", {
                                  key: 0,
                                  class: "af-steps",
                                  start: b.start
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(b.items, (li, k) => {
                                    return (_openBlock(), _createElementBlock("li", { key: k }, _toDisplayString(li), 1))
                                  }), 128))
                                ], 8, _hoisted_12))
                              : (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(b.text), 1))
                          ], 64))
                        }), 128))
                      ]),
                      (m.sources && m.sources.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "af-src-label" }, "From your playbook", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.sources, (s) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: s.Slug,
                                type: "button",
                                class: "af-src-btn",
                                onClick: ($event: any) => (_ctx.openEntry(s))
                              }, [
                                _createElementVNode("span", null, _toDisplayString(s.Name), 1),
                                _createElementVNode("em", null, _toDisplayString(_ctx.typeLabel(s.Type)), 1)
                              ], 8, _hoisted_15))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (m.related && m.related.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(m.found ? 'Also related' : 'Closest matches'), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.related, (s) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: s.Slug,
                                type: "button",
                                class: "af-src-btn af-src-plain",
                                onClick: ($event: any) => (_ctx.openEntry(s))
                              }, [
                                _createElementVNode("span", null, _toDisplayString(s.Name), 1),
                                _createElementVNode("em", null, _toDisplayString(_ctx.typeLabel(s.Type)), 1)
                              ], 8, _hoisted_18))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (i == _ctx.thread.length - 1 && m.followUps && m.followUps.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.followUps, (q) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: q,
                                type: "button",
                                class: "af-chip",
                                onClick: ($event: any) => (_ctx.ask(q))
                              }, _toDisplayString(q), 9, _hoisted_20))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
              ], 64))
            }), 128)),
            (_ctx.busy)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("span", null, null, -1),
                  _createElementVNode("span", null, null, -1),
                  _createElementVNode("span", null, null, -1),
                  _createTextVNode(" Reading your playbook…", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true)
          ], 512),
          _createElementVNode("form", {
            class: "af-input",
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.ask(_ctx.question)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("textarea", {
              id: "af-question",
              ref: "input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.question) = $event)),
              rows: "1",
              maxlength: "1000",
              placeholder: "Ask a question…",
              "aria-label": "Your question",
              onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.ask(_ctx.question)), ["exact","prevent"]), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.question]
            ]),
            _createVNode(_component_ai_dictation, {
              class: "af-mic",
              onText: _cache[5] || (_cache[5] = t => _ctx.question = (_ctx.question ? _ctx.question.trimEnd() + ' ' : '') + t)
            }),
            _createElementVNode("button", {
              type: "submit",
              class: _normalizeClass(["ai-btn af-send", { 'disable-button': _ctx.busy || !_ctx.question.trim() }]),
              "aria-label": "Ask"
            }, [...(_cache[16] || (_cache[16] = [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                "aria-hidden": "true"
              }, [
                _createElementVNode("path", { d: "M4 12h14M13 6l6 6-6 6" })
              ], -1)
            ]))], 2)
          ], 32),
          _createElementVNode("footer", _hoisted_23, [
            _cache[18] || (_cache[18] = _createElementVNode("span", null, "Answers come from your company's playbook.", -1)),
            (_ctx.canForge)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/ai-hub",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeOnPhone()))
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("Open the Forge", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
  ], 2))
}